import React, { useState, useEffect } from 'react';
import { authFetch } from '../auth/AuthContext';

const ROLES = ['Appraiser','Attorney','Borrower','Broker','Buyers Agent','CPA','Capital Partner','Contractor','Escrow Officer','GAP Funder','HOA','Insurance Agent','JV Partner','Listing Agent','Loan Officer','Notary','Other','PM Lender','Park Manager','Park Owner','Processor','Property Manager','Referral Partner','Seller','Title Officer','Wholesaler'];
const STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA',
  'KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
  'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT',
  'VA','WA','WV','WI','WY','DC'
];
const ENTITY_TYPES      = ['Individual','LLC','Corporation','Partnership','Trust','Other'];
const FUNDS_SOURCES     = ['Own funds','Gift','Partner','Business','Other'];
const FUNDS_IN_ACCT     = ['In account','Pending from another source','Coming from sale','HELOC pending'];
const SREO_TYPES        = ['SFR','Condo','Multi-Family','Commercial','MH','Land','Other'];
const SREO_STATUSES     = ['Owned free & clear','Has mortgage','Listed for sale','In rehab','Other'];
const ASSET_TYPES       = ['Checking','Savings','Money Market','CD','401k','IRA','Brokerage','Gift funds','Crypto','Other'];
const BANKRUPTCY_TYPES  = ['Chapter 7','Chapter 11','Chapter 13'];
const BANKRUPTCY_STATUS = ['Active','Discharged'];
const COLLECTIONS_OPTS  = ['None','Some, see notes'];

const DECLARATION_KEYS = ['Bankruptcy history','Foreclosure history','Short sale / deed in lieu','Pending litigation','Tax liens or judgments','Foreign national','Veteran'];

const s = {
  backBtn:   { display:'flex', alignItems:'center', gap:'6px', background:'none', border:'none', color:'#154D97', fontSize:'12.5px', fontWeight:600, cursor:'pointer', marginBottom:'14px', padding:0, fontFamily:'inherit' },
  card:      { background:'#fff', borderRadius:'12px', border:'1px solid #C9D9EE', boxShadow:'0 1px 3px rgba(20,60,120,0.06)', overflow:'hidden', marginBottom:'16px' },
  secBar:    { background:'#D0E0F5', borderBottom:'1px solid #BCD2EC', padding:'9px 16px', display:'flex', alignItems:'center', gap:'10px' },
  secTitle:  { color:'#154D97', fontSize:'11.5px', fontWeight:700, letterSpacing:'0.06em', textTransform:'uppercase' },
  secRight:  { marginLeft:'auto', display:'flex', alignItems:'center', gap:'10px' },
  caretBtn:  { background:'none', border:'none', color:'#4A7FBF', cursor:'pointer', fontSize:'15px', padding:0, lineHeight:1, fontFamily:'inherit' },
  syncChip:  { fontSize:'10px', fontWeight:600, padding:'2px 8px', borderRadius:'10px', background:'#F0F5FB', color:'#1A5FA8' },
  saveNote:  { fontSize:'11px', color:'#8A9AB5' },
  saveWarn:  { fontSize:'11px', color:'#8a5a12', fontWeight:600 },
  saveErr:   { fontSize:'11px', color:'#A23A2E', fontWeight:600 },
  saveBtn:   on => ({ fontSize:'12px', fontWeight:600, padding:'7px 14px', background: on ? '#154D97' : '#E4EDF8', color: on ? '#fff' : '#8A9AB5', border:'none', borderRadius:'8px', cursor: on ? 'pointer' : 'default', fontFamily:'inherit' }),
  headBody:  { padding:'14px 16px 16px' },
  hName:     { fontSize:'15px', fontWeight:700, color:'#2E4763' },
  hSub:      { fontSize:'11.5px', color:'#8A9AB5', marginTop:'2px' },
  mbBar:     { display:'flex', background:'#F0F5FB', border:'1px solid #D9E5F4', borderRadius:'10px', padding:'9px 0', marginTop:'12px', overflowX:'auto' },
  mbTile:    { padding:'0 18px', flexShrink:0 },
  mbDiv:     { width:'1px', alignSelf:'stretch', background:'#D9E5F4', flexShrink:0 },
  mbK:       { fontSize:'8.5px', fontWeight:700, letterSpacing:'0.06em', textTransform:'uppercase', color:'#7189B0', whiteSpace:'nowrap' },
  mbV:       { fontSize:'14px', fontWeight:600, color:'#154D97', marginTop:'2px', whiteSpace:'nowrap' },
  mbVWarn:   { fontSize:'14px', fontWeight:600, color:'#8a5a12', marginTop:'2px', whiteSpace:'nowrap' },
  sub:       { background:'#E4EDF8', padding:'6px 16px', fontSize:'10.5px', fontWeight:700, letterSpacing:'0.06em', textTransform:'uppercase', color:'#154D97', display:'flex', alignItems:'center' },
  subLbl:    { fontSize:'10.5px', fontWeight:700, letterSpacing:'0.06em', textTransform:'uppercase', color:'#154D97', marginTop:'16px', marginBottom:'9px' },
  inlineBox: { border:'1px solid #E9EFF6', borderRadius:'10px', background:'#fff', padding:'14px 15px 15px', margin:'12px 16px 14px' },
  flowFlat:  { display:'flex', flexWrap:'wrap', alignItems:'flex-end', gap:'12px 14px' },
  cancelBtn: { background:'#fff', border:'1px solid #C5D5EA', color:'#33415A', borderRadius:'8px', padding:'8px 16px', fontSize:'13px', fontWeight:600, fontFamily:'inherit', cursor:'pointer' },
  delBtn:    { background:'#fff', border:'1px solid #E0B4B4', color:'#A33333', borderRadius:'8px', padding:'8px 16px', fontSize:'13px', fontWeight:600, fontFamily:'inherit', cursor:'pointer', marginLeft:'auto' },
  delWarn:   { marginTop:'11px', fontSize:'12px', color:'#B4532A', background:'#FBF3EE', border:'1px solid #E8D3C4', borderRadius:'8px', padding:'9px 11px' },
  grid:      { display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px 16px', padding:'12px 16px 16px' },
  flow:      { display:'flex', flexWrap:'wrap', alignItems:'flex-end', gap:'12px 14px', padding:'12px 16px 16px' },
  flowTop:   { display:'flex', flexWrap:'wrap', alignItems:'flex-end', gap:'12px 14px', padding:'12px 16px 0' },
  grid3:     { display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'12px 16px', padding:'12px 16px 16px' },
  fK:        { fontSize:'11px', color:'#8A9AB5', marginBottom:'4px' },
  input:     { width:'100%', padding:'8px 10px', border:'1px solid #C9D9EE', borderRadius:'8px', fontSize:'13px', fontFamily:'inherit', color:'#2E4763', background:'#fff', outline:'none', boxSizing:'border-box' },
  select:    { width:'100%', padding:'8px 10px', border:'1px solid #C9D9EE', borderRadius:'8px', fontSize:'13px', fontFamily:'inherit', color:'#2E4763', background:'#fff', outline:'none', cursor:'pointer', boxSizing:'border-box' },
  textarea:  { width:'100%', padding:'9px 11px', border:'1px solid #C9D9EE', borderRadius:'8px', fontSize:'13px', fontFamily:'inherit', color:'#2E4763', background:'#fff', outline:'none', resize:'vertical', minHeight:'80px', boxSizing:'border-box' },
  chipsField:{ display:'flex', alignItems:'center', flexWrap:'wrap', gap:'4px', padding:'5px 8px', border:'1px solid #C9D9EE', borderRadius:'8px', background:'#fff', minHeight:'36px', boxSizing:'border-box' },
  pill:      { display:'inline-flex', alignItems:'center', gap:'4px', fontSize:'10px', fontWeight:600, padding:'2px 8px', borderRadius:'10px', background:'#E4EDF8', color:'#154D97', cursor:'pointer' },
  chipAdd:   { border:'none', background:'transparent', fontSize:'11px', color:'#8A9AB5', fontFamily:'inherit', outline:'none', cursor:'pointer', flex:1, minWidth:'80px' },
  rowItem:   { display:'flex', alignItems:'center', gap:'10px', padding:'10px 16px', borderBottom:'1px solid #EEF1F5', fontSize:'12.5px', cursor:'pointer' },
  rowCaret:  { color:'#4A7FBF', fontSize:'13px', flexShrink:0, width:'14px' },
  typeChip:  { fontSize:'9.5px', fontWeight:700, letterSpacing:'0.04em', textTransform:'uppercase', padding:'2px 7px', borderRadius:'6px', background:'#E4EDF8', color:'#154D97', flexShrink:0 },
  rowTitle:  { fontWeight:600, color:'#2E4763' },
  rowSub:    { fontSize:'11px', color:'#8A9AB5', marginTop:'1px' },
  rowRight:  { marginLeft:'auto', display:'flex', gap:'18px', alignItems:'center', flexShrink:0 },
  rV:        { textAlign:'right' },
  rVk:       { fontSize:'8.5px', fontWeight:700, letterSpacing:'0.06em', textTransform:'uppercase', color:'#7189B0' },
  rVv:       { fontSize:'12.5px', fontWeight:600, color:'#154D97' },
  rowEdit:   { background:'#F6F9FC', borderBottom:'1px solid #EEF1F5', padding:'4px 0 8px' },
  removeLink:{ background:'none', border:'none', color:'#A23A2E', fontSize:'11.5px', fontWeight:600, cursor:'pointer', fontFamily:'inherit', padding:'0 16px 8px' },
  addRow:    { display:'block', width:'calc(100% - 32px)', margin:'12px 16px 16px', border:'1px dashed #C9D9EE', background:'transparent', borderRadius:'9px', padding:'9px', textAlign:'center', fontSize:'12px', fontWeight:600, color:'#154D97', cursor:'pointer', fontFamily:'inherit' },
  emptyRow:  { padding:'12px 16px 0', fontSize:'12px', color:'#8A9AB5' },
  qHint:     { padding:'10px 16px 0', fontSize:'11.5px', color:'#8A9AB5' },
  qRow:      { display:'flex', alignItems:'center', justifyContent:'space-between', gap:'14px', padding:'10px 16px', borderBottom:'1px solid #EEF1F5', fontSize:'12.5px', color:'#33415A' },
  qSel:      { width:'96px', flexShrink:0, padding:'7px 10px', border:'1px solid #C9D9EE', borderRadius:'8px', fontSize:'13px', color:'#2E4763', fontFamily:'inherit', outline:'none', background:'#fff', cursor:'pointer' },
  reveal:    { margin:'8px 16px', padding:'2px 0 4px', background:'#F6F9FC', border:'1px solid #EEF1F5', borderRadius:'9px' },
  revealTitle:{ padding:'10px 16px 0', fontSize:'10.5px', fontWeight:700, letterSpacing:'0.06em', textTransform:'uppercase', color:'#154D97' },
  stChip:    { fontSize:'10px', fontWeight:600, padding:'2px 8px', borderRadius:'10px', background:'#F0F5FB', color:'#1A5FA8', flexShrink:0 },
  okChip:    { fontSize:'10px', fontWeight:600, padding:'2px 8px', borderRadius:'10px', background:'#EAF3DE', color:'#3B6D11', flexShrink:0 },
  warnChip:  { fontSize:'10px', fontWeight:600, padding:'2px 8px', borderRadius:'10px', background:'#FAEEDA', color:'#8a5a12', flexShrink:0 },
  loadingText:{ padding:'12px 16px', fontSize:'12.5px', color:'#8A9AB5' },
  avatar:    { width:'44px', height:'44px', borderRadius:'50%', background:'#E4EDF8', display:'flex', alignItems:'center', justifyContent:'center', color:'#154D97', fontSize:'15px', fontWeight:700, flexShrink:0 },
};

const fmt  = n => (!n && n !== 0) ? '-' : '$' + Number(n).toLocaleString();
const fmtD = n => n ? '$' + Number(n).toLocaleString() : '';
const pN   = x => String(x).replace(/[^0-9.]/g, '');
const num  = x => Number(x) || 0;

function formatPhone(val) {
  const n = String(val).replace(/[^0-9]/g, '');
  if (n.length <= 3) return n;
  if (n.length <= 6) return n.slice(0, 3) + '-' + n.slice(3);
  return n.slice(0, 3) + '-' + n.slice(3, 6) + '-' + n.slice(6, 10);
}

function initials(name) {
  if (!name) return '?';
  const p = name.trim().split(' ');
  if (p.length >= 2) return (p[0][0] + p[p.length - 1][0]).toUpperCase();
  return p[0][0].toUpperCase();
}

function FL({ label, children, w }) {
  return <div style={w ? { width:w, flexShrink:0 } : undefined}><div style={s.fK}>{label}</div>{children}</div>;
}

function AF({ label, value, onChange, type = 'text', placeholder, money, w }) {
  return (
    <FL label={label} w={w}>
      <input
        style={s.input}
        type={money ? 'text' : type}
        value={money ? (value ? fmtD(value) : '') : (value || '')}
        placeholder={placeholder || (money ? '$' : '')}
        onChange={e => onChange(money ? pN(e.target.value) : e.target.value)}
      />
    </FL>
  );
}

function ASel({ label, value, onChange, options, allowEmpty = true, w }) {
  return (
    <FL label={label} w={w}>
      <select style={s.select} value={value || ''} onChange={e => onChange(e.target.value)}>
        {allowEmpty && <option value=""></option>}
        {options.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    </FL>
  );
}

function LinkedDeals({ linkedIds }) {
  const [deals,   setDeals]   = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!linkedIds || !linkedIds.length) return;
    setLoading(true);
    authFetch('/.netlify/functions/get-deals')
      .then(r => r.json())
      .then(d => setDeals((d.records || []).filter(rec => linkedIds.includes(rec.id))))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [linkedIds]);

  if (loading) return <div style={s.loadingText}>Loading deals...</div>;
  if (!deals.length) return <div style={{ ...s.emptyRow, paddingBottom:'12px' }}>No deals linked to this contact.</div>;

  return (
    <div>
      {deals.map(d => {
        const f = d.fields || {};
        return (
          <div key={d.id} style={{ ...s.rowItem, cursor:'default' }}>
            {f['Loan type'] && <span style={s.typeChip}>{f['Loan type']}</span>}
            <div>
              <div style={s.rowTitle}>{f['Deal name'] || 'Unnamed deal'}</div>
              <div style={s.rowSub}>{[f['Property city'], f['Property state']].filter(Boolean).join(', ')}</div>
            </div>
            <div style={s.rowRight}>
              <span style={s.stChip}>{f['Stage'] || 'New intake'}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function ContactDetail({ contactId, contact: contactProp, onBack, onSaved, onDeleted }) {
  const [contact,        setContact]        = useState(contactProp || null);
  const [contactLoading, setContactLoading] = useState(!contactProp);
  const [form,           setForm]           = useState(null);
  const [dirty,          setDirty]          = useState(false);
  const [saving,         setSaving]         = useState(false);
  const [saved,          setSaved]          = useState(false);
  const [saveError,      setSaveError]      = useState('');
  const [sreoRows,       setSreoRows]       = useState([]);
  const [sreoLoading,    setSreoLoading]    = useState(true);
  const [assetRows,      setAssetRows]      = useState([]);
  const [assetLoading,   setAssetLoading]   = useState(true);
  const [collapsed,      setCollapsed]      = useState({});
  const [openSreo,       setOpenSreo]       = useState({});
  const [openAsset,      setOpenAsset]      = useState({});
  const [deleting,       setDeleting]       = useState(false);
  const [delError,       setDelError]       = useState('');

  useEffect(() => {
    if (contactProp) { setContact(contactProp); setContactLoading(false); return; }
    if (!contactId)  { setContactLoading(false); return; }
    authFetch(`/.netlify/functions/get-single-contact?contactId=${contactId}`)
      .then(r => r.json())
      .then(d => setContact(d))
      .catch(() => {})
      .finally(() => setContactLoading(false));
  }, [contactId, contactProp]);

  useEffect(() => {
    if (!contact) return;
    const f = contact.fields || {};
    setForm({
      'First name':              f['First name']              || '',
      'Last name':               f['Last name']               || '',
      'Email':                   f['Email']                   || '',
      'Phone':                   f['Phone']                   || '',
      'Company / entity':        f['Company / entity']        || '',
      'Entity type':             f['Entity type']             || '',
      'Tax ID':                  f['Tax ID']                  || '',
      'Unit':                    f['Unit']                    || '',
      'W-9 on file':             !!f['W-9 on file'],
      'Street address':          f['Street address']          || '',
      'City':                    f['City']                    || '',
      'Home state':              Array.isArray(f['Home state']) ? f['Home state'] : [f['Home state']].filter(Boolean),
      'ZIP':                     f['ZIP']                     || '',
      'County':                  f['County']                  || '',
      'Role(s)':                 Array.isArray(f['Role(s)']) ? f['Role(s)'] : [],
      'States active':           Array.isArray(f['States active']) ? f['States active'] : [],
      'FICO score':              f['FICO score']              || '',
      'Completed projects':      f['Completed projects']      || '',
      'Foreign national':        !!f['Foreign national'],
      'Veteran':                 !!f['Veteran'],
      'Source of funds':         f['Source of funds']         || '',
      'Total liquid assets':     f['Total liquid assets']     || '',
      'Funds in account status': f['Funds in account status'] || '',
      'Funds source notes':      f['Funds source notes']      || '',
      'Bankruptcy history':      !!f['Bankruptcy history'],
      'Bankruptcy type':         f['Bankruptcy type']         || '',
      'Bankruptcy date':         f['Bankruptcy date']         || '',
      'Bankruptcy status':       f['Bankruptcy status']       || '',
      'Foreclosure history':     !!f['Foreclosure history'],
      'Foreclosure date':        f['Foreclosure date']        || '',
      'Short sale / deed in lieu': !!f['Short sale / deed in lieu'],
      'Pending litigation':      !!f['Pending litigation'],
      'Tax liens or judgments':  !!f['Tax liens or judgments'],
      'Mortgage lates 12mo':     f['Mortgage lates 12mo']     || '',
      'Other lates 12mo':        f['Other lates 12mo']        || '',
      'Collections / charge-offs': f['Collections / charge-offs'] || '',
      'Credit events notes':     f['Credit events notes']     || '',
      'Notes':                   f['Notes']                   || '',
      'Last contacted':          f['Last contacted']          || '',
    });
  }, [contact]);

  const set = k => val => { setForm(p => ({ ...p, [k]: val })); setDirty(true); };

  // SREO and assets are no longer rendered on this record, so they are not fetched.
  // The save loops below iterate empty arrays and write nothing. No Airtable row is touched.

  function updateSreoRow(idx, key, val)  { setSreoRows(prev => prev.map((r, i) => i === idx ? { ...r, [key]: val } : r)); setDirty(true); }
  function updateAssetRow(idx, key, val) { setAssetRows(prev => prev.map((r, i) => i === idx ? { ...r, [key]: val } : r)); setDirty(true); }

  function addSreoRow() {
    setSreoRows(prev => [...prev, { _isNew: true }]);
    setOpenSreo(p => ({ ...p, [sreoRows.length]: true }));
    setDirty(true);
  }
  function addAssetRow() {
    setAssetRows(prev => [...prev, { _isNew: true }]);
    setOpenAsset(p => ({ ...p, [assetRows.length]: true }));
    setDirty(true);
  }

  async function handleDeleteSreo(idx) {
    const row = sreoRows[idx];
    if (row._id) {
      try { await authFetch('/.netlify/functions/delete-sreo', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ sreoId: row._id }) }); } catch(e) { console.error(e); }
    }
    setSreoRows(prev => prev.filter((_, i) => i !== idx));
    setOpenSreo({});
  }
  async function handleDeleteAsset(idx) {
    const row = assetRows[idx];
    if (row._id) {
      try { await authFetch('/.netlify/functions/delete-asset', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ assetId: row._id }) }); } catch(e) { console.error(e); }
    }
    setAssetRows(prev => prev.filter((_, i) => i !== idx));
    setOpenAsset({});
  }

  function toggleCard(id)  { setCollapsed(p => ({ ...p, [id]: !p[id] })); }

  async function saveAll() {
    if (!dirty || saving) return;
    setSaving(true); setSaveError('');
    try {
      const fields = { ...form };
      if (fields['FICO score'])           fields['FICO score']           = parseInt(fields['FICO score'])           || 0;
      if (fields['Completed projects'])   fields['Completed projects']   = parseInt(fields['Completed projects'])   || 0;
      if (fields['Mortgage lates 12mo'])  fields['Mortgage lates 12mo']  = parseInt(fields['Mortgage lates 12mo'])  || 0;
      if (fields['Other lates 12mo'])     fields['Other lates 12mo']     = parseInt(fields['Other lates 12mo'])     || 0;
      if (fields['Total liquid assets'])  fields['Total liquid assets']  = parseFloat(pN(String(fields['Total liquid assets']))) || 0;
      if (!Array.isArray(fields['Home state']))    fields['Home state']    = [fields['Home state']].filter(Boolean);
      if (!Array.isArray(fields['States active'])) fields['States active'] = [];
      if (!Array.isArray(fields['Role(s)']))       fields['Role(s)']       = [];

      if (!fields['Bankruptcy history']) {
        delete fields['Bankruptcy type'];
        delete fields['Bankruptcy date'];
        delete fields['Bankruptcy status'];
      }
      if (!fields['Foreclosure history']) {
        delete fields['Foreclosure date'];
      }

      Object.keys(fields).forEach(k => {
        if (Array.isArray(fields[k]) || typeof fields[k] === 'boolean') return;
        if (fields[k] === '' || fields[k] === null || fields[k] === undefined) delete fields[k];
      });

      const contactRes  = await authFetch('/.netlify/functions/update-contact', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ contactId: contact.id, fields }) });
      const contactData = await contactRes.json();
      if (contactData.error) throw new Error(contactData.error?.message || JSON.stringify(contactData.error));
      if (typeof onSaved === 'function') onSaved(contact.id, fields);

      for (const row of sreoRows) {
        const sreoFields = {
          'Property address': row['Property address'] || '',
          'Property type':    row['Property type']    || '',
          'Current value':    parseFloat(pN(String(row['Current value']   || ''))) || 0,
          'Loan balance':     parseFloat(pN(String(row['Loan balance']    || ''))) || 0,
          'Monthly payment':  parseFloat(pN(String(row['Monthly payment'] || ''))) || 0,
          'Lender name':      row['Lender name'] || '',
        };
        if (row['Status']) sreoFields['Status'] = row['Status'];
        if (row._id) {
          const res = await authFetch('/.netlify/functions/update-sreo', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ sreoId: row._id, fields: sreoFields }) });
          const data = await res.json();
          if (data.error) throw new Error('SREO save failed: ' + (data.error?.message || JSON.stringify(data.error)));
        } else {
          const res = await authFetch('/.netlify/functions/create-sreo', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ fields: { ...sreoFields, Contact: [contact.id] } }) });
          const data = await res.json();
          if (data.error) throw new Error('SREO create failed: ' + (data.error?.message || JSON.stringify(data.error)));
          row._id = data.id; row._isNew = false;
        }
      }

      for (const row of assetRows) {
        const assetFields = {
          'Institution name': row['Institution name'] || '',
          'Balance':          parseFloat(pN(String(row['Balance'] || ''))) || 0,
          'Verified':         !!row['Verified'],
        };
        if (row['Asset type'])        assetFields['Asset type']        = row['Asset type'];
        if (row['Account last 4'])    assetFields['Account last 4']    = row['Account last 4'];
        if (row['Verification date']) assetFields['Verification date'] = row['Verification date'];
        if (row._id) {
          const res = await authFetch('/.netlify/functions/update-asset', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ assetId: row._id, fields: assetFields }) });
          const data = await res.json();
          if (data.error) throw new Error('Asset save failed: ' + (data.error?.message || JSON.stringify(data.error)));
        } else {
          const res = await authFetch('/.netlify/functions/create-asset', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ fields: { ...assetFields, Contact: [contact.id] } }) });
          const data = await res.json();
          if (data.error) throw new Error('Asset create failed: ' + (data.error?.message || JSON.stringify(data.error)));
          row._id = data.id; row._isNew = false;
        }
      }

      setContact(prev => ({ ...prev, fields: { ...(prev?.fields || {}), ...fields } }));
      setDirty(false);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch(e) {
      setSaveError('Save failed: ' + e.message);
      console.error(e);
    } finally {
      setSaving(false);
    }
  }

  if (contactLoading) return <div style={s.inlineBox}><div style={s.loadingText}>Loading contact...</div></div>;
  if (!contact) return <div style={s.inlineBox}><div style={{ ...s.loadingText, color:'#A23A2E' }}>Contact not found.</div></div>;
  if (!form) return null;

  const cf          = contact.fields || {};
  const displayName = cf['Name'] || `${form['First name'] || ''} ${form['Last name'] || ''}`.trim() || 'Unnamed contact';
  const roles       = form['Role(s)'] || [];
  const isBorrower  = roles.includes('Borrower');
  async function deleteContact() {
    if (deleting) return;
    setDelError('');
    const dealCount = (cf['Deals'] || []).length;
    if (dealCount > 0) {
      setDelError(`${displayName || 'This contact'} is on ${dealCount} deal${dealCount === 1 ? '' : 's'}. Remove them from those deals before deleting the contact.`);
      return;
    }
    if (!window.confirm(`Delete ${displayName || 'this contact'} permanently? This cannot be undone.`)) return;
    setDeleting(true);
    try {
      const res = await authFetch('/.netlify/functions/delete-contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ recordId: contact.id }),
      });
      const d = await res.json();
      if (d && d.error) throw new Error(d.error?.message || JSON.stringify(d.error));
      if (typeof onDeleted === 'function') onDeleted(contact.id);
    } catch (e) {
      setDelError(e.message || 'Could not delete that contact.');
      setDeleting(false);
    }
  }

  const entity      = form['Company / entity'] || '';
  const homeStateVal = Array.isArray(form['Home state']) ? (form['Home state'][0] || '') : (form['Home state'] || '');

  const totalAll        = assetRows.reduce((a, r) => a + num(r['Balance']), 0);
  const totalSreoEquity = sreoRows.reduce((a, r) => a + (num(r['Current value']) - num(r['Loan balance'])), 0);
  const flagsOn         = DECLARATION_KEYS.filter(k => !!form[k]).length;
  const linkedDealIds   = cf['Deals'] || [];
  const paidAllTime     = Array.isArray(cf['Total paid']) ? cf['Total paid'].reduce((a,x)=>a+(Number(x)||0),0) : (Number(cf['Total paid'])||0);
  const payoutCount     = Array.isArray(cf['Payouts count']) ? cf['Payouts count'].length : (Number(cf['Payouts count'])||0);
  const referralCount   = Array.isArray(cf['Referral deals']) ? cf['Referral deals'].length : (Number(cf['Referral deals'])||0);

  const headTitle = entity ? `${displayName} - ${entity}` : displayName;
  const headSub   = [roles.join(' \u00B7 ') || 'No role', form['Last contacted'] ? `Last contacted: ${form['Last contacted']}` : 'Last contacted: never'].join(' \u00B7 ');

  return (
    <div style={s.inlineBox}>
      <div style={s.flowFlat}>
        <AF w="130px" label="First name" value={form['First name']} onChange={set('First name')} />
        <AF w="130px" label="Last name" value={form['Last name']} onChange={set('Last name')} />
        <AF w="215px" label="Email" value={form['Email']} onChange={set('Email')} type="email" />
        <AF w="140px" label="Phone" value={form['Phone']} onChange={val => { setForm(p => ({ ...p, Phone: formatPhone(val) })); setDirty(true); }} type="tel" placeholder="000-000-0000" />
        <ASel w="190px" label="Role" value={roles[0] || ''} onChange={v => set('Role(s)')(v ? [v] : [])} options={ROLES} />
      </div>

      <div style={s.subLbl}>Address</div>
      <div style={s.flowFlat}>
        <AF w="430px" label="Street address" value={form['Street address']} onChange={set('Street address')} />
        <AF w="100px" label="Unit / Suite" value={form['Unit']} onChange={set('Unit')} />
      </div>
      <div style={{ ...s.flowFlat, marginTop:'12px' }}>
        <AF w="180px" label="City" value={form['City']} onChange={set('City')} />
        <ASel w="110px" label="State" value={homeStateVal} onChange={v => set('Home state')([v].filter(Boolean))} options={STATES} />
        <AF w="110px" label="ZIP" value={form['ZIP']} onChange={set('ZIP')} />
        <AF w="150px" label="County" value={form['County']} onChange={set('County')} />
      </div>

      <div style={s.subLbl}>Company / Entity</div>
      <div style={s.flowFlat}>
        <AF w="245px" label="Business name" value={form['Company / entity']} onChange={set('Company / entity')} />
        <ASel w="150px" label="Entity type" value={form['Entity type']} onChange={set('Entity type')} options={ENTITY_TYPES} />
        <AF w="130px" label="Tax ID" value={form['Tax ID']} onChange={set('Tax ID')} />
        <FL w="150px" label="W-9 on file">
          <label style={{display:'inline-flex',width:'fit-content',alignItems:'center',gap:'9px',fontSize:'13px',color:'#33415A',height:'34px',cursor:'pointer'}}>
            <input type="checkbox" checked={!!form['W-9 on file']} onChange={e => set('W-9 on file')(e.target.checked)} style={{width:'16px',height:'16px',accentColor:'#154D97',cursor:'pointer'}} />
            {form['W-9 on file'] ? 'On file' : 'Not on file'}
          </label>
        </FL>
      </div>

      {(paidAllTime>0 || payoutCount>0) && (
        <React.Fragment>
          <div style={s.subLbl}>Paid to date</div>
          <div style={{display:'flex',gap:'34px',flexWrap:'wrap'}}>
            <div><div style={{fontSize:'9.5px',letterSpacing:'0.07em',textTransform:'uppercase',color:'#8FA6C4',fontWeight:700}}>Paid all time</div><div style={{fontSize:'15px',color:'#154D97',fontWeight:700,marginTop:'3px'}}>{'$'+Math.round(paidAllTime).toLocaleString()}</div></div>
            <div><div style={{fontSize:'9.5px',letterSpacing:'0.07em',textTransform:'uppercase',color:'#8FA6C4',fontWeight:700}}>Payouts</div><div style={{fontSize:'15px',color:'#154D97',fontWeight:700,marginTop:'3px'}}>{payoutCount}</div></div>
            <div><div style={{fontSize:'9.5px',letterSpacing:'0.07em',textTransform:'uppercase',color:'#8FA6C4',fontWeight:700}}>Deals referred</div><div style={{fontSize:'15px',color:'#154D97',fontWeight:700,marginTop:'3px'}}>{referralCount}</div></div>
          </div>
          <div style={{fontSize:'10.5px',color:'#8A94A6',marginTop:'4px'}}>Read from the payout rows on every deal. Nothing is typed here.</div>
        </React.Fragment>
      )}

      <div style={s.subLbl}>Internal notes</div>
      <textarea style={s.textarea} value={form['Notes'] || ''} onChange={e => set('Notes')(e.target.value)} placeholder="No notes yet. Type to add." />

      <div style={{ display:'flex', alignItems:'center', gap:'9px', marginTop:'16px' }}>
        <button style={s.saveBtn(dirty && !saving)} onClick={saveAll}>{saving ? 'Saving...' : 'Save contact'}</button>
        <button style={s.cancelBtn} onClick={onBack}>Cancel</button>
        {saveError
          ? <span style={s.saveErr}>{saveError}</span>
          : dirty
            ? <span style={s.saveWarn}>Unsaved changes</span>
            : saved ? <span style={s.saveNote}>Saved</span> : null}
        <button style={s.delBtn} disabled={deleting} onClick={deleteContact}>{deleting ? 'Deleting...' : 'Delete contact'}</button>
      </div>
      {delError && <div style={s.delWarn}>{delError}</div>}
    </div>
  );
}
